var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinContent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79427 6.46995C7.79427 6.21536 7.61011 6.00953 7.36094 5.93912C6.67302 5.74953 6.16927 5.1212 6.16927 4.3737V1.66536H6.71094C7.00885 1.66536 7.2526 1.42161 7.2526 1.1237C7.2526 0.825781 7.00885 0.582031 6.71094 0.582031H1.29427C0.996354 0.582031 0.752604 0.825781 0.752604 1.1237C0.752604 1.42161 0.996354 1.66536 1.29427 1.66536H1.83594V4.3737C1.83594 5.1212 1.33219 5.74953 0.644271 5.93912C0.395104 6.00953 0.210938 6.21536 0.210938 6.46995V6.54036C0.210938 6.83828 0.454688 7.08203 0.752604 7.08203H3.4501L3.46094 10.8737C3.46094 11.1716 3.70469 11.4154 4.0026 11.4154C4.30052 11.4154 4.54427 11.1716 4.54427 10.8737L4.53344 7.08203H7.2526C7.55052 7.08203 7.79427 6.83828 7.79427 6.54036V6.46995Z",
    fill: "#4D6F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinContent);
export default __webpack_public_path__ + "static/media/PinContent.38aa3687e374b1ea9aa61b35450d59c7.svg";
export { ForwardRef as ReactComponent };